import { Asset } from '@/_models/Token';
import TokenService  from "@/services/TokenService";
import { Helper } from "@/utils/Helper";

export class TokenUtils{

  static async getWalletUnusedAssets (walletAddress: string, network: string):Promise<Asset[]> {
    const assetDetails = await TokenService.getAssetList(walletAddress, network);
    if(assetDetails.status == 200){
      return assetDetails.data;
    }else if(assetDetails.status == 204){
      return [];
    }else{
      Helper.endpointErrorHandling('Error fetching assets. Please try again later.');
      return [];
    }
  }
}